import script from "./DetalharPoliticaCobranca.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalharPoliticaCobranca.vue?vue&type=script&setup=true&lang=js"

import "./DetalharPoliticaCobranca.vue?vue&type=style&index=0&id=7ddb80f4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ddb80f4"]])

export default __exports__